<!-- modal.component.html -->
<div class="modal-backdrop" (click)="close.emit()"></div>
<div class="modal-dialog">
  <div class="modal-header">
    <div class="modal-title" *ngIf="title">{{ title }}</div>
    <button class="modal-close-btn" (click)="close.emit()" title="Close">✕</button>
  </div>

  <div class="modal-body">
    <ng-container #modalContentContainer></ng-container>
    <p *ngIf="!componentContent && textContent" style="white-space:pre-wrap;font-size:12px;line-height:1.6;color:var(--text);">{{ textContent }}</p>
  </div>

  <div class="modal-footer">
    <button class="pxl-btn pxl-btn-primary" *ngIf="saveButtonText" (click)="onSave()">
      {{ saveButtonText }}
    </button>
    <button class="pxl-btn pxl-btn-primary" *ngIf="confirmButtonText" (click)="confirm.emit()">
      {{ confirmButtonText }}
    </button>
  </div>
</div>
